import React from "react";
import ScrollToTop from "../component/ScrollToTop";
import Header from "../component/Header";
import Footer from "../component/Footer";
export default function About() {
  return (
    <>
      <ScrollToTop>
        <Header />
        <section className="hero_padding">
          <div className="container">
            <div className="row justify-content-center mb-md-5 mb-4 mt-md-0 mt-4">
              <div className="col-12">
                <h2 className="heading-2 text-center">
                  Enabling growth with intelligent supply chain{" "}
                  <br className="d-md-block d-none" /> finance and payment
                  solutions
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-3 col-6">
                <div className="count_border">
                  <h2 className="heading-1 fw-normal small_text">$208b</h2>
                  <p className="font_14 fw-bold">in transactions per year</p>
                </div>
              </div>
              <div className="col-xl-3 col-6">
                <div className="count_border">
                  <h2 className="heading-1 fw-normal small_text">33m</h2>
                  <p className="font_14 fw-bold">accounts created yearly</p>
                </div>
              </div>
              <div className="col-xl-3 col-6">
                <div className="count_border">
                  <h2 className="heading-1 fw-normal small_text">3b</h2>
                  <p className="font_14 fw-bold">transactions per year</p>
                </div>
              </div>
              <div className="col-xl-3 col-6">
                <div className="text-center">
                  <h2 className="heading-1 fw-normal small_text">30m</h2>
                  <p className="font_14 fw-bold">
                    accounts migrated until 2024
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding pt-0">
          <div className="container">
            <div className="row g-lg-5 g-4 align-items-center">
              <div className="col-lg-6">
                <h6 className="sub_para small_text fw-normal text-uppercase mb-xl-4">
                  Our Company
                </h6>
                <h2 className="heading-2 mb-xl-4 mb-3">Who we are</h2>
                <p className="sub_para">
                  Blockcryp Labs is a worldwide financial technology firm
                  developing ways to integrate the cryptocurrency market with
                  the established financial system.
                </p>
                <p className="sub_para">
                  We have been developing and enhancing our core blockchain and
                  web3 technologies since 2017 in an effort to bring web3 into
                  the public in a safe and legal manner.
                </p>
                <p className="sub_para">
                  Blockcryp Labs has operations in the UK and India and employs
                  more than 160 employees worldwide.
                </p>
              </div>
              <div className="col-lg-6 text-center text-lg-start">
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/dummy.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding pt-0">
          <div className="container">
            <div className="row g-lg-5 g-4 align-items-center">
              <div className="col-lg-6 text-center text-lg-start">
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/dummy.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
              <div className="col-lg-6 ">
                <h6 className="sub_para small_text fw-normal text-uppercase mb-xl-4">
                  Our Vision
                </h6>
                <h2 className="heading-2 mb-xl-4 mb-3">
                  Building the new <br className="d-lg-block d-none" /> economy
                </h2>
                <p className="sub_para">
                  Value creation and distribution are two more areas that are
                  being revolutionised by blockchain and tokenization.
                </p>
                <p className="sub_para">
                  We're using this tech to create a more fair and prosperous
                  economy that benefits everyone, not just the wealthy few.
                </p>
                <p className="sub_para">
                  Blockcryp Labs has operations in the UK and India and employs
                  more than 160 employees worldwide.
                </p>
                <h6 className="sub_para small_text fw-normal text-uppercase mb-xl-4">
                  Member of
                </h6>
                <div className="d-flex gap-5">
                  <img
                    src="assets/img/about/deo.png"
                    alt=""
                    className="deo_img"
                  />
                  <img src="assets/img/about/web3.png" alt="" />
                  <img src="assets/img/about/eth.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding bg-blue">
          <div className="container">
            <div className="row g-lg-5 g-4">
              <div className="col-12 text-center">
                <h6 className="sub_para fw-normal text-uppercase mb-xl-4">
                  our values
                </h6>
                <h2 className="heading-2 mb-xl-5">What we believe in</h2>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-4 blue_card">
                  <img
                    src="assets/img/about/Inclusive.svg"
                    alt=""
                    className=""
                  />
                </div>
                <h4 className="sub_heading mb-3">Inclusive</h4>
                <p className="sub_para">
                  To make web3 accessible to everyone, everywhere
                </p>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-4 blue_card">
                  <img src="assets/img/about/Efficient.svg" alt="" />
                </div>
                <h4 className="sub_heading mb-3">Efficient</h4>
                <p className="sub_para">
                  To offer an automated and frictionless experience
                </p>
              </div>
              <div className="col-lg-3 col-md-6 ">
                <div className="mb-4 blue_card">
                  <img
                    src="assets/img/about/Reliable.svg"
                    alt=""
                    className=""
                  />
                </div>
                <h4 className="sub_heading mb-3">Reliable</h4>
                <p className="sub_para">
                  To be as transparent and verifiable as we can
                </p>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-4 blue_card">
                  <img src="assets/img/about/Complaint.svg" alt="" />
                </div>
                <h4 className="sub_heading mb-3">Complaint</h4>
                <p className="sub_para">
                  To engage regulators and comply with existing rules
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding">
          <div className="container">
            <div className="row g-lg-5 g-4">
              <div className="col-lg-6">
                <h6 className="sub_para small_text fw-normal text-uppercase mb-xl-4">
                  our people's
                </h6>
                <h2 className="heading-2">Key Founders</h2>
                <p className="sub_para text_grey fw-normal">
                  Their visionary leadership has led Blockcryp Labs to the
                  forefront of the blockchain revolution, where trust is no
                  longer centralized but distributed across the network.
                </p>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="assets/img/639b830a4cbdd20fd5f3a9a9/dummy.png"
                      alt=""
                      className="img-fluid"
                    />
                    <p className="sub_para mt-3 mb-0">Aman Vaths</p>
                    <span className="font_12 text_grey">CTO & Founder</span>
                    <div className="d-flex align-items-center mb-md-0 mb-2">
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="assets/img/639b830a4cbdd20fd5f3a9a9/dummy.png"
                      alt=""
                      className="img-fluid"
                    />
                    <p className="sub_para mt-3 mb-0">Aman Vaths</p>
                    <span className="font_12 text_grey">CTO & Founder</span>
                    <div className="d-flex align-items-center mb-md-0 mb-2">
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="assets/img/639b830a4cbdd20fd5f3a9a9/dummy.png"
                      alt=""
                      className="img-fluid"
                    />
                    <p className="sub_para mt-3 mb-0">Aman Vaths</p>
                    <span className="font_12 text_grey">CTO & Founder</span>
                    <div className="d-flex gap-2 align-items-center">
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row g-lg-5 g-4 mt-md-5 mt-3">
              <div className="col-lg-6">
                <h6 className="sub_para small_text fw-normal text-uppercase mb-xl-4">
                  our company
                </h6>
                <h2 className="heading-2">Senior management</h2>
                <p className="sub_par text_grey fw-normal">
                  Our top management is made up of individuals with extensive
                  backgrounds in both traditional and cutting-edge sectors of
                  the business world.
                </p>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="assets/img/639b830a4cbdd20fd5f3a9a9/dummy.png"
                      alt=""
                      className="img-fluid"
                    />
                    <p className="sub_para mt-3 mb-0">Aman Vaths</p>
                    <span className="font_12 text_grey">CTO & Founder</span>
                    <div className="d-flex align-items-center mb-md-0 mb-2">
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="assets/img/639b830a4cbdd20fd5f3a9a9/dummy.png"
                      alt=""
                      className="img-fluid"
                    />
                    <p className="sub_para mt-3 mb-0">Aman Vaths</p>
                    <span className="font_12 text_grey">CTO & Founder</span>
                    <div className="d-flex align-items-center mb-md-0 mb-2">
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="assets/img/639b830a4cbdd20fd5f3a9a9/dummy.png"
                      alt=""
                      className="img-fluid"
                    />
                    <p className="sub_para mt-3 mb-0">Aman Vaths</p>
                    <span className="font_12 text_grey">CTO & Founder</span>
                    <div className="d-flex gap-2 align-items-center">
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-blue section_padding">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h2 className="heading-2">
                  Looking for development or collabration?
                </h2>
                <p className="sub_para">
                  Unlock the full potential of blockchain technology and joint
                  knowledge by requesting a price or calling us today.
                </p>
                <div className="d-flex justify-content-center gap-2">
                  <div className="black-round">
                    <img src="assets/img/about/phone.svg" alt="" />
                  </div>
                  <div className="black-round">
                    <img src="assets/img/about/mail.svg" alt="" />
                  </div>
                  <div className="black-round">
                    <img src="assets/img/about/twitter.svg" alt="" />
                  </div>
                  <div className="black-round">
                    <img src="assets/img/about/linkedin.svg" alt="" />
                  </div>
                </div>
                <div className="d-flex justify-content-center pt-xl-4 pt-3">
                  <button
                    className="btn bg-black font_14 fw-bold px-3 text-white
                      rounded"
                  >
                    Request for Demo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </ScrollToTop>
    </>
  );
}
